/** @format */

import Filter from '../interfaces/forms/Filter';
import moment from 'moment';

export const PreprocessFilters = (filters: Array<Filter>): Array<Filter> => {
    const newFilters: Array<Filter> = [];
    for (let i = 0; i < filters.length; i++) {
        const value = filters[i].value;

        if (Array.isArray(value)) {
            for (let j = 0; j < value.length; j++) {
                const valueT = value[j];

                if (typeof valueT === 'string' && !/^\d+$/.test(valueT) && moment(valueT).isValid()) {
                    newFilters.push({ name: filters[i].name, value: value });
                } else {
                    newFilters.push({ name: filters[i].name + '[]', value: encodeURIComponent(valueT) });
                }
            }
        } else {
            if (typeof value === 'string' && moment(value).isValid()) {
                newFilters.push({ name: filters[i].name, value: value });
            } else {
                newFilters.push({ name: filters[i].name, value: encodeURIComponent(value) });
            }
        }
    }
    return newFilters;
};
